import React, { useState } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import img1 from "../../assets/AmberSuiteImg/AS2.jpg";
import img2 from "../../assets/AmberSuiteImg/AS3.jpg";
import img3 from "../../assets/AmberSuiteImg/AS4.jpg";
import img4 from "../../assets/AmberSuiteImg/AS5.jpg";
import img5 from "../../assets/AmberSuiteImg/AS6.jpg";
import img6 from "../../assets/AmberSuiteImg/AS7.jpg";
import img7 from "../../assets/AmberSuiteImg/AS8.jpg";
import img8 from "../../assets/AmberSuiteImg/AS9.jpg";

const images = [
  { src: img1, alt: "Image 1" },
  { src: img2, alt: "Image 2" },
  { src: img3, alt: "Image 3" },
  { src: img4, alt: "Image 4" },
  { src: img5, alt: "Image 5" },
  { src: img6, alt: "Image 6" },
  { src: img7, alt: "Image 7" },
  { src: img8, alt: "Image 8" },
];

const columns = [
  [
    { src: img1, alt: "Image 1" },
    { src: img2, alt: "Image 2" },
    { src: img3, alt: "Image 3" },
  ],
  [
    { src: img4, alt: "Image 4" },
    { src: img5, alt: "Image 5" },
  ],
  [
    { src: img6, alt: "Image 6" },
    { src: img7, alt: "Image 7" },
    { src: img8, alt: "Image 8" },
  ],
];

const AmberImageList = () => {
  const [open, setOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleOpen = (index) => {
    setCurrentImageIndex(index);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "1.5%",
          maxWidth: "100%",
          width: "95%", // Remove vertical margins
          paddingBottom: "0", // Ensure no padding at the bottom
          boxSizing: "border-box", // Include padding and borders in dimensions
        }}
      >

        {columns.map((col, colIndex) => (
          <Box
            key={colIndex}
            sx={{ display: "flex", flexDirection: "column", gap: "2%" }}
          >
            {col.map((img, imgIndex) => {
              const overallIndex =
                columns
                  .slice(0, colIndex)
                  .reduce((acc, curr) => acc + curr.length, 0) + imgIndex;

              // Conditionally apply extra margin to Image 5
              const customStyles =
                colIndex === 1 && imgIndex === 1
                  ? { marginTop: "1.5%" } // Adjust this value to control the extra gap
                  : {};

              return (
                <Box
                  key={imgIndex}
                  sx={{
                    position: "relative",
                    cursor: "pointer",
                    ...customStyles, // Apply conditional styles
                  }}
                  onClick={() => handleOpen(overallIndex)}
                >
                  <Box
                    component="img"
                    src={img.src}
                    alt={img.alt}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  {img.hasOverlay && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <PlayArrowIcon sx={{ fontSize: "5vw", color: "#fff" }} />
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        ))}

      </Box>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          backgroundColor: "rgba(128, 128, 128, 0.7)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: "-5%",
              right: "1%",
              width: "5%",
              height: "7%",
              border: "1px solid #E1D9CF",
              backgroundColor: "transparent",
              borderRadius: "0",
              padding: "0",
            }}
          >
            <CloseIcon sx={{ fontSize: "1.6vw", color: "#E1D9CF" }} />
          </IconButton>
          <Box
            component="img"
            src={images[currentImageIndex].src}
            alt={images[currentImageIndex].alt}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              top: "50%",
              left: "1%",
              transform: "translateY(-50%)",
              width: "5%",
              height: "7%",
              border: "1px solid #E4CAAE",
              backgroundColor: "transparent",
              borderRadius: "0",
              padding: "0",
            }}
          >
            <ArrowBackIcon sx={{ fontSize: "1.6vw", color: "#A88765" }} />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: "1%",
              transform: "translateY(-50%)",
              width: "5%",
              height: "7%",
              border: "1px solid #E1D9CF",
              backgroundColor: "transparent",
              borderRadius: "0",
              padding: "0",
            }}
          >
            <ArrowForwardIcon sx={{ fontSize: "1.6vw", color: "#A88765" }} />
          </IconButton>
        </Box>
      </Modal>
    </>
  );
};

export default AmberImageList;
